import { StorageService } from './storage.service';
import { Options } from 'selenium-webdriver/safari';
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Session } from '../models/session';
import { LoginObject } from '../models/login-object';
import { ENPOINT } from './endpoint';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry } from 'rxjs/operators';
import { HttpParams , HttpHeaders, HttpResponse} from '@angular/common/http';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { User } from '../models/user';

@Injectable()
export class AuthenticationService {
  private basePath;

  constructor(private http: HttpClient,
              private storageService: StorageService,
              private _router: Router) {
                this.basePath = ENPOINT.url;
              }

  login(loginObj: LoginObject, idioma: string): Observable<any> {
    const options = {
       withCredentials: true,
       headers: new HttpHeaders({
        'Content-Type': 'application/json'  }),
        params: new HttpParams()
      .set('user', loginObj.username)
      .set('pass', loginObj.password)
      .set('idioma', idioma)
     } ; 
    return this.http.get(this.basePath + 'auth/login', options)
    .pipe(
      retry(3)
    );
  }

    private extractData(res: Response) {
    const body = res.json();
    return body;
    }

  cerrarSesion() {
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
      'Content-Type': 'application/json'})
    };
    return this.http.get(this.basePath + 'auth/logout', options)
    .pipe(
      retry(3)
    );
  }

  cambiarCorreo(userId, newEmail) {
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
      'Content-Type': 'application/json'}),
      params: new HttpParams()
      .set('email', newEmail)
    };
    return this.http.put(this.basePath + 'users/' + userId + '/credentials', options)
    .pipe(
      retry(3)
    );
  }

  cambiarPassword(userId, newPassword) {
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
      'Content-Type': 'application/json'}),
      params: new HttpParams()
      .set('password', newPassword)
    };
    return this.http.put(this.basePath + 'users/' + userId + '/credentials', '', options)
    .pipe(
      retry(3)
    );
  }

  recuperarPassword(username, idioma): Observable<any> {
    const options = {
      withCredentials: true,
      headers: new HttpHeaders({
        'Content-Type': 'application/json'  }),
        params: new HttpParams()
      .set('username', username)
      .set('idioma', idioma)
    };
    return this.http.get(this.basePath + 'auth/resetpassword', options)
    .pipe(
      retry(3)
    );
  }

  crearRegistro(registro, idioma): Observable<any> {
    if (typeof (registro.rfcUsuario) == 'string') {
      registro.rfcUsuario = registro.rfcUsuario.toUpperCase();
    }
    const options = {
       withCredentials: true,
       headers: new HttpHeaders({
        'Content-Type': 'application/json'  }),
        params: new HttpParams()
      .set('nombre', registro.nombreUsuario)
      .set('direccion', registro.direccionUsuario)
      .set('telefono', registro.telefonoUsuario)
      .set('rfc', registro.rfcUsuario)
      .set('email', registro.correoUsuario)
      .set('pass', registro.passUsuario)
      .set('conf-pass', registro.cpassUsuario)
      .set('tipo', registro.tipo)
      .set('idioma', idioma)
     } ;

    return this.http.post(this.basePath + 'users/registro', '', options);
  }


}




// WEBPACK FOOTER //
// ./src/app/services/authentication.service.ts